import React from "react";
import SvgIcon, { SvgIconProps } from "../SvgIcon";
import { default as FriendlyBadgeIconSrc } from '../assets/friendly-badge.svg';

export const FriendlyBadgeIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <FriendlyBadgeIconSrc />
  </SvgIcon>
);
